<template>
  <tbody>
    <tr :class="[{more_info: isEditable && $_updateActionAllowed}, { open: isOpen }, {disabled: !isEditable}]" @click="triggerIfEditable">
      <td data-th="Název" class="first_data" @click="goToDetail">{{ entity.name }}</td>
      <td data-th="ID">{{ entity.id_channel }}</td>
      <td data-th="Přemapované ID">{{ entity.id_mapped }}</td>
      <td data-th="Přidal">{{ entity.user_created }}</td>
      <td data-th="Přidáno" class="last_data"><span class="date" v-html="$_date_formatFull(entity.timestamp_created)"></span></td>
      <td class="no_padding edit">
        <div class="edit_inner">
          <a
              v-if="$_deleteActionAllowed"
              class="btn btn_action btn_delete"
              :title="'Smazat' | translate"
              @click.prevent.stop="emitDeleteChannel">
            <translate class="translate">Smazat</translate>
          </a>
        </div>
      </td>
    </tr>
    <tr :class="['more_info_content', { open: isOpen }]">
      <td class="first_data"></td>

      <td></td>

      <td>
          <text-input
              id="id_mapped"
              v-model="entity.id_mapped"
              :required="true">
              <translate class="translate">Přemapované ID</translate>
          </text-input>
      </td>

      <td></td>

      <td>
        <p>
          <input
              class="btn"
              type="submit"
              :value="'Uložit' | translate"
              @click.stop.prevent="emitUpdateChannel"
          >
        </p>
      </td>
      <td><p></p></td>
    </tr>
  </tbody>
</template>

<script>

export default {
  name: 'AdvertisingProviderChannelGroupDetailChannelRow',
  mixins: [],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      moduleName: 'advertisingProviders',
      isOpen: false,
    }
  },
    methods: {
      goToDetail() {
        this.$router.push({name: 'channelDetail', params: {id: this.entity.id_channel}})
      },
      triggerIfEditable() {
        if (this.isEditable && this.$_updateActionAllowed) {
          this.isOpen = !this.isOpen
        }
      },
      emitUpdateChannel() {
        this.$emit('updateChannel', this.entity)
      },
      emitDeleteChannel() {
        this.$emit('deleteChannel', this.entity.id_channel)
      },
  },
  computed: {
    isChecked() {
      return this.selectedEntities.indexOf(String(this.props.entity.id)) > -1
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingProviders/channelGroup/ChannelRow.vue